export default __webpack_public_path__ + "static/hero-mobile-b366873c3975090b22fcded03beb3da7.jpg";